import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "The Living Model", target: "living-model" },
  { label: "Real Situations", target: "real-situations" },
  { label: "Use Cases", target: "use-cases" },
  { label: "The Advantage", target: "advantage" },
];

export const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (target: string) => {
    if (location.pathname !== "/") {
      navigate(`/#${target}`);
      return;
    }
    document.getElementById(target)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 border-b border-border/70 bg-background/90 backdrop-blur-xl">
      <nav className="mx-auto flex h-[108px] max-w-7xl items-center justify-between px-5 md:px-8">
        <Link to="/" className="text-base font-bold uppercase tracking-[0.12em] text-primary md:text-lg">TruthForge AI</Link>
        <div className="hidden items-center gap-8 lg:flex">
          {navItems.map((item) => (
            <button key={item.target} onClick={() => scrollToSection(item.target)} className="text-[10px] font-bold uppercase tracking-[0.12em] text-body transition hover:text-foreground">
              {item.label}
            </button>
          ))}
          <Link to="/insights" className="text-[10px] font-bold uppercase tracking-[0.12em] text-body transition hover:text-foreground">
            Insights
          </Link>
          <Link to="/whitepaper" className="text-[10px] font-bold uppercase tracking-[0.12em] text-body transition hover:text-foreground">
            Whitepaper
          </Link>
        </div>
        <button onClick={() => location.pathname === "/" ? document.getElementById("contact-form")?.scrollIntoView({ behavior: "smooth" }) : navigate("/#contact-form")} className="hidden rounded-[6px] bg-primary px-5 py-3 text-[10px] font-bold uppercase tracking-[0.08em] text-primary-foreground transition hover:bg-primary/90 sm:inline-flex">
          Request a Stress-Test
        </button>
      </nav>
    </header>
  );
};
